import { Seo } from "@/components/site/Seo";
import { PageIntro } from "@/components/site/PageIntro";
import { useLang } from "@/i18n";

const EssayHeading = ({ overline, children, index }) => (
  <div className="mt-20 mb-10" data-testid={`essay-heading-${index}`}>
    <p className="text-[10px] tracking-[0.32em] uppercase font-semibold text-[#374F49] mb-4">{overline}</p>
    <h2 className="font-serif font-medium text-3xl sm:text-4xl text-[#1A2522] leading-[1.15] tracking-tight">{children}</h2>
    <div className="mt-6 inline-block">
      <span className="divider"></span>
    </div>
  </div>
);

const Quote = ({ children }) => (
  <blockquote className="my-14 border-l-2 border-[#374F49] pl-6 sm:pl-8 py-2">
    <p className="font-serif italic text-2xl sm:text-[26.5px] text-[#1A2522] leading-[1.28]">{children}</p>
  </blockquote>
);

const Highlight = ({ children }) => (
  <aside data-testid="evidence-paradox-highlight" className="my-12 bg-[#374F49]/[0.06] border-l-2 border-[#374F49] px-6 sm:px-8 py-6">
    <p className="font-serif !text-xl sm:!text-[22px] text-[#1A2522] leading-[1.4] !m-0">{children}</p>
  </aside>
);

const AtAGlance = ({ title, paragraphs }) => (
  <section data-testid="philosophy-at-a-glance" className="max-w-3xl mb-16 sm:mb-20 bg-[#EAE5D9]/50 border-t border-b border-[#1A2522]/15 px-6 sm:px-10 py-10">
    <h2 data-testid="philosophy-at-a-glance-title" className="font-serif font-medium text-2xl sm:text-[28px] text-[#1A2522] leading-[1.2] tracking-tight">{title}</h2>
    <div className="mt-6 space-y-4">
      {paragraphs.map((t, i) => (
        <p key={i} className="text-[14px] sm:text-[15px] text-[#374F49] leading-[1.8]">{t}</p>
      ))}
    </div>
  </section>
);

const Block = ({ b, i }) => {
  if (b.t === "h") return <EssayHeading overline={b.overline} index={i}>{b.text}</EssayHeading>;
  if (b.t === "quote") return <Quote>{b.text}</Quote>;
  if (b.t === "highlight") return <Highlight>{b.text}</Highlight>;
  return <p>{b.text}</p>;
};

export default function Philosophy() {
  const p = useLang().t.philosophy;
  return (
    <>
      <Seo page="philosophy" />
      <PageIntro testId="philosophy-intro" overline={p.overline} title={p.title} italic={p.italic} />
      <article data-testid="essay-section" className="max-w-7xl mx-auto px-6 sm:px-12 pb-24 sm:pb-32">
        <AtAGlance title={p.glanceTitle} paragraphs={p.glance} />
        <div className="max-w-3xl essay-prose">
          {p.blocks.map((b, i) => (
            <Block key={i} b={b} i={i} />
          ))}
        </div>
      </article>
    </>
  );
}
